import React from 'react';
import { Button } from '@mui/material';
import { COGNITO_CLIENT_ID, COGNITO_REDIRECT_SIGNIN_URL, COGNITO_USER_POOL_URL } from '../../config.js';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';

interface OAuthButtonProps {
  brand?: 'microsoft';
  title: string;
  identityProvider: string;
}

const useStyles = makeStyles(() => ({
  loginBtn: {
    width: '220px',
    height: '40px',
    color: '#fff',
    fontWeight: 700,
    fontSize: '16px',
    borderRadius: '7px',
    backgroundColor: '#3E83E6',
    '&:hover,&:focus': {
      backgroundColor: '#3E83E6',
    },
  },
}));

const OAuthButton = ({ title, identityProvider }: OAuthButtonProps) => {
  const classes = useStyles();
  const handleClick = () => {
    window.location.assign(
      `https://${COGNITO_USER_POOL_URL}/oauth2/authorize?identity_provider=${encodeURIComponent(identityProvider)}&redirect_uri=${COGNITO_REDIRECT_SIGNIN_URL}/&response_type=TOKEN&client_id=${COGNITO_CLIENT_ID}`
    );
  };

  return (
    <Button onClick={handleClick} fullWidth={false} className={classes.loginBtn}>
      {title}
    </Button>
  );
};

OAuthButton.propTypes = {
  brand: PropTypes.oneOf(['microsoft']),
};
export default OAuthButton;
